<template>
    <h3 class="mb-0" style="line-height: 20px">{{ title }}</h3>
    <jet-button
        v-if="!!href && showAction"
        class="px-0"
        style="min-width: 0"
        type="button"
        variant="tertiary"
        @click.stop="$inertia.visit(href)"
    >
        <slot name="label">
            <icon v-if="actionIcon" :icon="actionIcon" />
            <span v-if="label">{{ label }}</span>
        </slot>
    </jet-button>
</template>
<script setup>
import Icon from '@/Components/Icon.vue';
import JetButton from '@/Jetstream/Button.vue';

defineProps(['title', 'label', 'href', 'icon', 'actionIcon', 'showAction']);
</script>
<style scoped>
:deep(.disabled a) {
    color: #ccc;
}
</style>
